import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import iconBack from "../../assets/images/quailai.svg";
import iconArrowLeft from "../../assets/images/arrow-left.svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import { useCategories } from "../../categorys/locking/index";
import toast from "react-hot-toast";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import { useStepCommission } from "../../hooks/useStepCommission";
import { useNavigate } from "react-router-dom";
import { useIndividualServiceFee } from "../../hooks/useIndividualServiceFee";
import { stepCommissionCall } from "../../api/stepCommission";
import { delay, formatPriceUS } from "../../utils/utils";
import { formatDateDb } from "../../utils/tools";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import { InputControl } from "../../components/form/formControls";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import PaymentPeriodForm from "./paymentPeriodForm";

const schemaAdd = Yup.object().shape({
  lockingId: Yup.string().required("mã đợt locking là bắt buộc"),
  // period: Yup.number()
  //   .nullable()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .required("Số đợt là bắt buộc"),
  // % có thể để trống -> tự lấy 100 − Σ% các đợt đã có (thanh toán nốt phần còn lại).
  paymentPercent: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    }),
});

const TableLocking = ({ lockingId, period }) => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const accordionRef = useRef(null);
  const [search, setSearch] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };
  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    lockingManagementData,
    dataOrigin,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useIndividualServiceFee(debouncedSearchTerm, lockingId, period);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const [stepCommission, setStepCommission] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [openIndexes, setOpenIndexes] = useState([]);
  const [paymentPeriods, setPaymentPeriods] = useState([]);

  const {
    register,
    setValue,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaAdd),
    defaultValues:
      {
        lockingId,
        // period,
      } || {},
  });

  const getInfomationStepCommission = async (lockingId, period) => {
    const data =
      await stepCommissionCall.getStepCommissionByLockingId(lockingId);
    if (data) {
      setStepCommission(data);

      // const max = 100 - Number(data?.paymentPercent || 100);
      // if (max) {
      //   setValue("paymentPercent", max);
      // }

      const dataList = await stepCommissionCall.getPaymentPeriodList(
        lockingId,
        // period
      );
      // console.log({dataList})
      // Sắp xếp theo số đợt tăng dần (BE cũng đã sort, đây là chốt chặn phía FE để
      // "Đợt 2" không bao giờ hiện trên "Đợt 1").
      if (dataList)
        setPaymentPeriods(
          [...(dataList?.items || [])].sort(
            (a, b) => Number(a?.periodPayment || 0) - Number(b?.periodPayment || 0)
          )
        );
    }
  };

  useEffect(() => {
    if (lockingId) getInfomationStepCommission(lockingId);
  }, [lockingId]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Mã nhân viên",
        key: "code",
      },
      {
        label: "Tên nhân viên",
        key: "fullName",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      {
        label: "Tổng PDV sau thuế",
        key: "remainingRevenueAfterTax",
      },
      {
        label: "Tổng PDV đã TT",
        key: "commissionPrice",
      },
      {
        label: "PDV còn lại",
        key: "remainingCommission",
      },
    ],
    data: lockingManagementData,
  };

  // table
  const handleNavigate = (e) => {
    navigate(
      `/step-commission/disbursement?lockingId=${e?.lockingId}&period=${e?.period}`,
    );
  };

  const newStepCommission = async (data) => {
    const stepInfo = {
      lockingId: data.lockingId,
      period: data.period,
      periodPayment: paymentPeriods.length + 1,
      paymentPercent: data.paymentPercent,
    };

    const toastCreate = toast.loading("Đang thêm đợt thanh toán ...");
    try {
      const { periodPayment, ...data } = stepInfo;

      await stepCommissionCall.createPaymentPeriod({
        ...data,
      });
      await refetch();
      await getInfomationStepCommission(stepInfo.lockingId, stepInfo.period);
      toast.success("Thêm thành công");

      await delay(300);
      setOpenIndex(Number(paymentPeriods.length) - 1);
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi thêm");
    }

    toast.dismiss(toastCreate);

    setTimeout(() => {
      if (accordionRef.current) {
        accordionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }, 300);
  };

  const submitHandler = (data) => {
    submit(data);
  };

  const submit = (data) => {
    const hasActiveStatus = paymentPeriods.some((item) => item.status === true);

    if (hasActiveStatus) {
      toast.error(
        "Đã có đợt thanh toán đang hoạt động, vui lòng xác nhận đợt đó trước khi thêm mới",
      );
      return;
    }

    // % để trống -> lấy 100 − Σ% các đợt đã có (phần còn lại chưa thanh toán).
    const otherPercentSum = paymentPeriods.reduce(
      (s, p) => s + Number(p.paymentPercent || 0),
      0,
    );
    const defaultPercent = Math.max(0, Math.round((100 - otherPercentSum) * 100) / 100);
    const percent =
      data.paymentPercent != null && !Number.isNaN(Number(data.paymentPercent))
        ? Number(data.paymentPercent)
        : defaultPercent;

    setPaymentPeriods([
      ...paymentPeriods,
      {
        id: new Date().getTime(),
        lockingId: data.lockingId,
        period: data.period,
        periodPayment: paymentPeriods.length + 1,
        paymentPercent: percent,
        remainingRevenueAfterTax: 0,
        projectId: stepCommission?.projectId,
        projectObject: stepCommission?.projectObject,
        apartmentId: stepCommission?.apartmentId,
        apartmentObject: stepCommission?.apartmentObject,
        status: true,
      },
    ]);

    // handlePageChange(paymentPeriods.length + 1)
    // newStepCommission(data);
    setOpenIndexes([...openIndexes, paymentPeriods.length]);
    setTimeout(() => {
      if (accordionRef.current) {
        accordionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }, 300);
  };

  const deleteHandler = async (id, status) => {
    console.log({ id, status });
    if (status && id) {
      const updatedList = paymentPeriods.filter((item) => item.id !== id);
      setPaymentPeriods(updatedList);
      return;
    }
  };

  return (
    <>
      <Box w={"full"}>
        <Text
          fontSize={"20px"}
          lineHeight={"19px"}
          fontWeight={"600"}
          color={"var(--color-header-employee)"}
          mb={"16px"}
        >
          Đợt thanh toán
          {/* {stepCommission?.period || ""} */}
        </Text>

        {/* 1 */}
        <Box w={"100%"} mb={"20px"}>
          {/* 1 */}
          <Flex
            mt={8}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            gap={3}
            mb={"12px"}
            w={"100%"}
            flexWrap={"wrap"}
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            p={"16px 0px 12px 16px"}
          >
            <Box flex={1}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
                mb={"16px"}
              >
                Thông tin chung
              </Text>
            </Box>
            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Mã căn
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${stepCommission?.apartmentObject?.code || ""} `}
                </Text>
              </Box>

              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Dự án
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${stepCommission?.projectObject?.name || stepCommission?.locking?.project?.name || ""} `}
                </Text>
              </Box>

              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tổng PDV sau thuế
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${formatPriceUS(
                    stepCommission?.totalRemainingRevenueAfterTax || 0,
                  )} VNĐ`}
                </Text>
              </Box>
            </Flex>

            <Flex
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              gap={"27px"}
              mb={"12px"}
              w={"100%"}
            >
              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tổng PDV đã thanh toán
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${formatPriceUS(stepCommission?.totalRemainingRevenueAfterTax - stepCommission?.totalRemainingCommission || 0)} VNĐ`}
                </Text>
              </Box>

              <Box flex={"1"}>
                <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                  Tổng PDV còn lại
                </Text>
                <Text
                  color={"var(--color-option-employee)"}
                  fontSize={"14px"}
                  fontWeight={"500"}
                  mt={"8px"}
                >
                  {`${formatPriceUS(
                    stepCommission?.totalRemainingCommission || 0,
                  )} VNĐ`}
                </Text>
              </Box>

              <Box flex={"1"}></Box>
            </Flex>
          </Flex>
        </Box>

        {/* 2 */}
        <Flex flexDirection={"column"} gap={{ base: "16px" }} mb={"20px"}>
          <Flex
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            flexDirection={"column"}
          >
            <Flex w={"full"} p={"16px 16px 12px 16px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
              >
                Danh sách nhân viên
              </Text>
            </Flex>
            <Flex
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={{ base: "32px" }}
              p={"16px 16px 12px 16px"}
            >
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                p={"16px 0px 12px 16px"}
                flexWrap={"wrap"}
              >
                <InputGroup
                  maxW="42vw"
                  minW={"42vw"}
                  borderRadius={{ base: "8px" }}
                  w={{ base: "100%" }}
                >
                  <Input
                    placeholder="Tên, mã nhân viên "
                    type="text"
                    borderRadius={{ base: "8px" }}
                    border={{ base: "1px solid var(--color-boder)" }}
                    backgroundColor={"var(--fill-avatar)"}
                    onChange={onChangeSearch}
                  />
                  <InputRightElement
                    borderTopRightRadius={"8px"}
                    borderBottomRightRadius={"8px"}
                    pointerEvents="none"
                    cursor={"pointer"}
                    backgroundImage="var(--color-button)"
                  >
                    <SearchIcon color="var(--color-main)" />
                  </InputRightElement>
                </InputGroup>
              </Flex>
            </Flex>
            <Box width={"100%"} height={"100%"}>
              <Skeleton isLoaded={!isLoading && !isRefetching}>
                <TableContainer
                  w={"100%"}
                  maxH="calc(100vh - 350.5px)"
                  overflowY="auto"
                >
                  <Table w={"100%"} variant="unstyled">
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      backgroundColor="#F9FAFD"
                    >
                      <Tr h={{ base: "41px" }}>
                        {tableData.headers.map((e, index) => {
                          let width = "auto";
                          let textAlign = "start";
                          if (e.key === "") {
                            width = "2%";
                            textAlign = "start";
                          } else if (e.key === "code") {
                            width = "5%";
                            textAlign = "start";
                          } else if (e.key === "fullName") {
                            width = "5%";
                            textAlign = "start";
                          } else if (e.key === "commissionPrice") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "remainingRevenueAfterTax") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "remainingCommission") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleBlock") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleArea") {
                            width = "10%";
                            textAlign = "start";
                          } else {
                            width = "10%";
                            textAlign = "start";
                          }
                          return (
                            <Td
                              p={"16px 16px 8px 16px"}
                              key={index}
                              border={"none"}
                              color={"#51607B"}
                              fontSize={{ base: "14px" }}
                              w={width}
                            >
                              <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {tableData.data?.length > 0 ? (
                        tableData.data?.map((e, rowIndex) => {
                          const items = { ...e };
                          delete items.id;
                          delete items.lockingId;
                          const keyValues = Object.keys(items);
                          return (
                            <Tr key={rowIndex} h={"72px"}>
                              <Td p={"16px 16px 8px 16px"} w={"2%"}>
                                <Menu>
                                  <MenuButton
                                    _hover={{ backgroundColor: "none" }}
                                    _active={{ backgroundColor: "none" }}
                                    background="none"
                                    as={Button}
                                  >
                                    <AiOutlineMore fontSize={"20px"} />
                                  </MenuButton>
                                </Menu>
                              </Td>
                              <Td p={"16px 16px 8px 16px"} w={"2%"}>
                                {rowIndex + 1}
                              </Td>
                              {keyValues.map((keyvalue, index) => {
                                let width = "auto";
                                let widthText = "100%";
                                let textAlign = "start";
                                let whiteSpace = "inherit";
                                if (keyvalue === "") {
                                  width = "2%";
                                  textAlign = "start";
                                } else if (keyvalue === "code") {
                                  width = "5%";
                                  textAlign = "start";
                                } else if (keyvalue === "fullName") {
                                  width = "5%";
                                  textAlign = "start";
                                } else if (keyvalue === "commissionPrice") {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "remainingRevenueAfterTax"
                                ) {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (keyvalue === "remainingCommission") {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleBlock") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleArea") {
                                  width = "10%";
                                  textAlign = "start";
                                } else {
                                  width = "10%";
                                  textAlign = "start";
                                  whiteSpace = "inherit";
                                }
                                return (
                                  <Td
                                    p={"16px 16px 8px 16px"}
                                    w={width}
                                    key={index}
                                  >
                                    <Box
                                      fontSize={{ base: "14px" }}
                                      lineHeight={"19.6px"}
                                      textAlign={"start"}
                                      fontWeight={500}
                                      color={"var(--color-info-employee)"}
                                      w={widthText}
                                      whiteSpace={whiteSpace}
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      display="-webkit-box"
                                      sx={{
                                        WebkitLineClamp: "2",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {formatTableValue(e[keyvalue], keyvalue)}
                                    </Box>
                                  </Td>
                                );
                              })}
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={tableData.headers.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Skeleton>
              <Box mt={10} mr={5} mb={5} ml={5}>
                <Flex alignItems={"center"} justifyContent={"space-between"}>
                  <Text>
                    Showing {startEntry} to {endEntry} of {entries} entries
                  </Text>
                  <HStack spacing={2} justify="flex-end">
                    <ReactPaginate
                      className="pagination-custom"
                      pageCount={totalPages}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      breakClassName={"ellipsis"}
                      breakLabel={"..."}
                      previousLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronLeft}
                        />
                      }
                      nextLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronRight}
                        />
                      }
                      renderOnZeroPageCount={null}
                      forcePage={currentPage - 1}
                    />
                  </HStack>
                </Flex>
              </Box>
            </Box>
          </Flex>
        </Flex>

        {/* 3 */}
        <Box
          w={"full"}
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
          p={"16px 16px 12px 16px"}
        >
          {/* button create step commission */}
          <form onSubmit={handleSubmit(submitHandler)}>
            <Flex
              justifyContent="space-between"
              alignItems={"center"}
              w={"full"}
              mb={4}
            >
              <Box>
                <InputControl
                  type="number"
                  label="Phần trăm thanh toán"
                  placeholder="Nhập phần trăm thanh toán VD: 30"
                  errors={errors.paymentPercent}
                  register={register("paymentPercent")}
                  onFocus={() => handleFocus("paymentPercent")}
                  onBlur={() => handleBlur("paymentPercent")}
                  state={focusStates["paymentPercent"]}
                  onlyPositiveNumbers={true}
                  isRate={true}
                />
              </Box>
              <Button
                w={"max-content"}
                mt={"16px"}
                display={"flex"}
                alignItems={"center"}
                p={"0px 12px"}
                gap={"10px"}
                borderRadius={"8px"}
                border={"1px solid var(--color-option-employee-hover)"}
                backgroundImage="var(--color-main)"
                bg={"var(--color-main)"}
                padding={"8px 12px"}
                h={"32px"}
                _hover={{
                  filter: "brightness(95%)",
                }}
                type="submit"
                isLoading={isLoading}
              >
                <Image src={iconPlus2} />
                <Text
                  fontSize={{ base: "13px" }}
                  lineHeight={"16px"}
                  fontWeight={600}
                  color="var(--color-option-employee-hover)"
                >
                  Thêm đợt thanh toán
                </Text>
              </Button>
            </Flex>
          </form>
          {/* List step */}
          <Accordion
            ref={accordionRef}
            index={openIndexes}
            onChange={(indexes) => {
              // console.log(indexes)
              setOpenIndexes(indexes);
            }}
            allowMultiple
          >
            {paymentPeriods.map((step, index) => (
              <AccordionItem key={index}>
                <AccordionButton>
                  <Box as="span" flex="1" textAlign="left">
                    <Text
                      fontSize={"16px"}
                      fontWeight={"600"}
                      color="var(--color-option-employee-hover)"
                    >
                      Thanh toán Đợt {step.periodPayment}
                      {step?.disbursementDate
                        ? ` - ${formatDateDb(step.disbursementDate)}`
                        : ""}
                      {step?.monthYears?.length
                        ? ` - ĐC: ${step.monthYears.join(", ")}`
                        : ""}
                    </Text>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  {openIndexes.includes(index) && (
                    <PaymentPeriodForm
                      id={step._id || step.id}
                      lockingId={step.lockingId}
                      period={step.period}
                      periodPayment={step.periodPayment}
                      paymentPercent={step.paymentPercent}
                      refetchParent={refetch}
                      getInfomationStepCommission={getInfomationStepCommission}
                      listEmployee={dataOrigin}
                      isFake={step.status}
                      deleteHandler={deleteHandler}
                      setOpenIndex={setOpenIndex}
                      accordionRef={accordionRef}
                      paymentPeriods={paymentPeriods}
                      step={step}
                    />
                  )}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Box>
    </>
  );
};

export default TableLocking;
